import { Typography } from 'antd';
import React from 'react';
import { t, jt } from 'ttag';

import Modal from '.';

export enum ActionType {
  DELETE = 'delete',
  ARCHIVE = 'archive',
}

const generateDefaultLabels = ({
  actionType = ActionType.DELETE,
  label: { singular, plural } = { singular: 'Item' },
  itemName,
  count,
  additionalInfo,
}: ConfirmProps) => {
  const formattedItemLabel =
    count > 1 ? (
      <Typography.Text key="itemLabel">
        {count} {plural}
      </Typography.Text>
    ) : (
      <Typography.Text key="itemLabel" strong>
        {itemName}
      </Typography.Text>
    );

  return {
    [ActionType.DELETE]: {
      title: count > 1 && plural ? t`Delete ${plural}?` : t`Delete ${singular}?`,
      okText: t`Yes, Delete`,
      cancelText: t`No, Cancel`,
      content: additionalInfo
        ? jt`Are you sure you want to delete ${formattedItemLabel}? ${additionalInfo} This action cannot be undone.`
        : jt`Are you sure you want to delete ${formattedItemLabel}? This action cannot be undone.`,
    },
    [ActionType.ARCHIVE]: {
      title: count > 1 && plural ? t`Archive ${plural}?` : t`Archive ${singular}?`,
      okText: t`Yes, Archive`,
      cancelText: t`No, Cancel`,
      content: jt`Are you sure you want to archive ${formattedItemLabel}? ${additionalInfo}`,
    },
  }[actionType];
};

interface ConfirmProps {
  title?: string;
  actionType?: ActionType;
  label?: {
    // will be used in Modal title
    singular: string;
    // will be used in Modal content when count > 1
    plural?: string;
  };
  itemName?: string;
  count?: number;
  additionalInfo?: string;
  content?: React.ReactNode;
  onDelete: () => void;
  onCancel?: () => void;
  okText?: string;
  cancelText?: string;
  confirmDisabled?: boolean;
}

const confirm = (props: ConfirmProps) => {
  const defaultLabels = generateDefaultLabels(props);

  return Modal.confirm({
    title: props.title ?? defaultLabels.title,
    content: props.content ?? defaultLabels.content,
    cancelText: props.cancelText ?? defaultLabels.cancelText,
    okText: props.okText ?? defaultLabels.okText,
    confirmDisabled: props.confirmDisabled,
    onOk: props.onDelete,
    onCancel: props.onCancel,
  });
};

const DeleteModal = {
  confirm,
};

export default DeleteModal;
